// extracted by mini-css-extract-plugin
export default {"sectionHeader":"HomePage_sectionHeader__rS4Of","eyebrow":"HomePage_eyebrow__PeX0W","sectionTitle":"HomePage_sectionTitle__W8-SA","sectionDesc":"HomePage_sectionDesc__MK3wK"};